export default function filterSearch() {
  let searchAjax = false;
  let searchWait = false;
  let searchResult = $('.search__result');
  let searchFilterResult = $('.search__filterResult');
  let form = $('.search .search__form');
  form.click(function (e) {
    e.preventDefault();
  })
  $('.search .search__input').on('input', function () {
    if ($('.search .search__input').val().length > 2) {
        
      if (searchAjax) searchAjax.abort();
        grecaptcha.ready(function () {
            grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
            action: 'submit'
            }).then(function (token) {
                $('.modalLoader').show();
                if (searchWait) clearTimeout(searchWait);
                searchWait = setTimeout(function () {
                    searchAjax = $.ajax({
                        headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                        },
                        type: form.attr('method'),
                        url: form.attr('action'),
                        data: form.serialize()+'&gRecaptchaResponse='+ token,
                        dataType: "json",
                        success: function (data) {
                            $('.modalLoader').hide();
                            let content = `<p class="search__qtdResult">${jsi18n.have_found} ${data.total} ${jsi18n.results}</p>
                                    <div class="search__filterContent">`;
                            $.each(data.contents, function (key, el) {
                            content += `<div class="search__filterIten">
                                        <div class="search__filterImage" style="background-image: url('${el.image}')"></div>
                                        <div class="search__filterText">
                                        <p class="search__filterSubtitle">${el.title}</p>
                                        <p class="search__filterPreview">${el.preview}</p>
                                        <a href="${el.link}" class="search__filterBtn">${jsi18n.see_more}</a>
                                        </div>
                                        </div>`;
                            })
                            content += `</div>`;
                            content += `<div class="search__ProductPagination">${data.pagination}</div>`;
                            searchResult.hide();
                            searchFilterResult.html(content).fadeIn();
                            searchAjax = false;
                        }
                    }).fail(function (jqXHR, textStatus, errorThrown) {
                        $('.modalLoader').hide();
                        searchAjax.abort();
                        searchAjax = false;
                    });
                }, 1500);

            });
        });

    } else {
        searchFilterResult.hide();
        searchResult.fadeIn();
        $('.modalLoader').hide();
    }
  });
  $('.search__filterResult').on('click', '.search__ProductPagination .pager.filter a', function (e) {
    e.preventDefault();
    var page = $(this).data('page');
   

    grecaptcha.ready(function () {
        
      grecaptcha.execute('6LdIr9sZAAAAADlV6TRsdi3aWTuw19tI6ZPilj1-', {
        action: 'submit'
      }).then(function (token) {
        $('.modalLoader').show();
        if (searchWait) clearTimeout(searchWait);
        searchWait = setTimeout(function () {
          if (searchAjax) searchAjax.abort();
          searchAjax = $.ajax({
            headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: form.attr('method'),
            url: form.attr('action'),
            data: form.serialize() + (page ? "&p=" + page + "&l=10" : null)+'&gRecaptchaResponse='+ token,
            dataType: "json",
            success: function (data) {
              let content = `<p class="search__qtdResult">${jsi18n.have_found} ${data.total} ${jsi18n.results}</p>
          <div class="search__filterContent">`;
              $.each(data.contents, function (key, el) {
                content += `<div class="search__filterIten">
            <div class="search__filterImage" style="background-image: url('${el.image}')"></div>
            <div class="search__filterText">
            <p class="search__filterSubtitle">${el.title}</p>
            <p class="search__filterPreview">${el.preview}</p>
            <a href="${el.link}" class="search__filterBtn">${jsi18n.see_more}</a>
            </div>
            </div>`;
              })
              content += `</div>`;
              content += `<div class="search__ProductPagination">${data.pagination}</div>`;
              searchResult.hide();
              searchFilterResult.html(content).fadeIn();
              searchAjax = false;
              $('.modalLoader').hide();
            }
          }).fail(function (jqXHR, textStatus, errorThrown) {
            $('.modalLoader').hide();
            searchAjax = false;
            console.log("Algo deu errado, tente novamente"); 
        });
        }, 1500);

      });
    });

  });
}